import React, { FunctionComponent } from 'react';
import { Headline, Link, Paragraph } from 'View/Common';
import { CustomScrollbar } from 'View/Component';
import { StyledModal } from '../Modal.style';

interface IProps {
  isOpen: boolean;
  toggle?: () => void;
}

export const HealthBenefitsModal: FunctionComponent<IProps> = ({ isOpen, toggle }) => {
  return (
    <StyledModal toggle={toggle} isOpen={isOpen} size="lg" headline={<Headline level={2}>Gesundheitlicher Nutzen</Headline>}>
      <CustomScrollbar>
        <Paragraph>
          Der gesundheitliche Nutzen des Kurses „Erholsamen Schlaf finden“ in der 7Schläfer-App wurde in einer wissenschaftlichen Studie
          nachgewiesen.
        </Paragraph>

        <Paragraph>
          Insgesamt nahmen 263 Personen an der Studie teil, davon 191 Personen in der Interventionsgruppe und 72 in der Wartekontrollgruppe.
          Über einen Zeitraum von ungefähr sieben Wochen absolvierten die Teilnehmenden das strukturierte Programm in der App, bestehend aus
          44 Audioeinheiten, praxisorientierten Übungen, Schlaf-Logbuch und Tipps zur Verbesserung der Schlafhygiene und des Ein- und
          Durchschlafens. Vor Beginn, direkt nach Kursabschluss sowie drei Monate nach Kursstart wurden standardisierte Messinstrumente
          eingesetzt. Die Ergebnisse zeigen deutliche Verbesserungen.
        </Paragraph>

        <Paragraph>
          Teilnehmende des Präventionskurses zeigten eine <strong>deutliche Verbesserung der Schlafprobleme (Insomnieschwere)</strong>{' '}
          zwischen Beginn und Abschluss des Kurses. Die Insomnie-Symptome (gemessen mit dem Insomnia Severity Index; ISI) reduzierten sich
          um durchschnittlich 4,8 Punkte nach Kursabschluss, was statistisch signifikant war und mit einer großen Effektstärke einherging
          (Cohen’s d = 1.35).
        </Paragraph>

        <Paragraph>
          Am Ende des Kurses erfüllten 48.17 % der Teilnehmenden in der Interventionsgruppe das Kriterium für Remission, d.h. sie
          berichteten allenfalls geringe oder unauffällige Schlafprobleme (ISI-Wert &lt; 8). Darüber hinaus erreichten 21.47 % der
          Interventionsgruppe eine klinisch bedeutsame Verbesserung (Definiert als Reduktion des ISI um mehr als 8 Punkte). Auch 3 Monate
          nach Abschluss des Kurses blieben die Insomnie-Symptome stabil auf dem niedrigeren Niveau (d = 1.40, ein großer Effekt).
        </Paragraph>

        <Paragraph>
          Auch die <strong>Schlafhygiene</strong> der Teilnehmenden verbesserte sich über die Kurslaufzeit signifikant, gemessen mit dem
          Sleep Hygiene Index (SHI). In der Interventionsgruppe sank der SHI-Wert um durchschnittlich 3.45 Punkte (d = 0.69, moderater
          Effekt).
        </Paragraph>

        <Paragraph>
          Signifikante Verbesserungen gab es in der Interventionsgruppe insbesondere bei schlafrelevanten Verhaltensweisen wie: Tagesschlaf
          (d = 0.23), unregelmäßige Zubettgehzeiten (d = 0.16), Stress und Nervosität beim Einschlafen (d = 0.51), Grübeln im Bett (d =
          0.78), abendlicher Arbeitsaktivität (d = 0.45), aktivierender Tätigkeiten vor dem Schlafen (d = 0.59), Sport innerhalb von 1
          Stunde vor dem Schlafen (d = 0.14), Nutzung des Bettes für andere Aktivitäten als den Schlaf (d = 0.47), sowie Schlafen in einem
          unbequemen Bett (d = 0.29) bzw. Zimmer (d = 0.28). Auch 3 Monate nach Abschluss des Kurses blieben die Werte für schlaffördernde
          Verhaltensweisen stabil (d = 0.94, ein moderater Effekt).
        </Paragraph>

        <Paragraph>
          Im digitalen <strong>Schlaftagebuch</strong> (Schlaflogbuch) der Interventionsgruppe ergaben sich signifikante Verbesserungen:
          Teilnehmende schliefen im Durchschnitt 8.40 Minuten schneller ein, als vor dem Kurs und wachten seltener auf in der Nacht
          (0.25-mal weniger). Die Zeit, die schlafend im Bett verbracht wurde, stieg um 4.28% an (im Vergleich zur Wachliegezeit im Bett;
          Schlafeffizienz) und Teilnehmende waren zufriedener mit ihrer eigenen Schlafqualität (+0.16 Punkte). Insgesamt gaben 68% der
          Teilnehmenden an, dass sich ihr Schlaf durch den Kurs nachhaltig verbessert hat.
        </Paragraph>

        <Paragraph>
          Die Studie zeigt somit, dass der app-gestützte Präventionskurs „Erholsamen Schlaf finden“ wirksam dazu beiträgt, Ein- und
          Durchschlafprobleme zu verringern und die Schlafqualität zu verbessern.
        </Paragraph>

        <Paragraph>
          Die vollständige Studie kann{' '}
          <Link href="https://static.7schlaefer.app/studie/ErholsamenSchlafFinden_Evaluation.pdf">an dieser Stelle</Link> heruntergeladen
          werden.
        </Paragraph>
      </CustomScrollbar>
    </StyledModal>
  );
};
